import { MessageCircle, Calculator, Phone } from "lucide-react";
import { COMPANY } from "@/data/services";

export default function FinalCTA() {
  const msg = encodeURIComponent(
    `Hola, vengo desde la web de ${COMPANY.name} y quiero solicitar una visita técnica para valorar mi reforma.`
  );
  return (
    <section className="bg-[#004B87] text-white scroll-mt-20" data-testid="final-cta">
      <div className="container mx-auto px-4 md:px-8 py-16 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-7">
            <div className="text-[11px] uppercase tracking-[0.25em] text-blue-200 font-semibold mb-3">¿Listo para el siguiente paso?</div>
            <h2 className="font-display font-semibold text-3xl md:text-5xl tracking-tight leading-[1.05]">
              ¿Quieres confirmar tu presupuesto?
            </h2>
            <p className="text-blue-100/90 mt-5 max-w-xl text-base md:text-lg leading-relaxed">
              La calculadora te ofrece una estimación inicial. Para darte un precio real y ajustado necesitamos revisar medidas, estado del soporte, accesos y materiales.
            </p>
          </div>
          <div className="lg:col-span-5 space-y-3">
            <a
              href={`https://wa.me/${COMPANY.whatsappIntl}?text=${msg}`}
              target="_blank" rel="noreferrer"
              data-testid="final-cta-whatsapp"
              className="flex items-center justify-center gap-3 h-14 px-6 rounded-xl bg-white text-[#004B87] font-display font-semibold text-base hover:bg-blue-50 transition-colors shadow-lg"
            >
              <MessageCircle className="w-5 h-5" />
              Solicitar visita técnica por WhatsApp
            </a>
            <a
              href="#calculadora"
              data-testid="final-cta-calculadora"
              className="flex items-center justify-center gap-3 h-14 px-6 rounded-xl border border-white/30 text-white font-display font-semibold text-base hover:bg-white/5 transition-colors"
            >
              <Calculator className="w-5 h-5" />
              Hacer nueva estimación
            </a>
            <a
              href={`tel:+34${COMPANY.whatsapp}`}
              data-testid="final-cta-call"
              className="flex items-center justify-center gap-3 h-12 text-blue-100 hover:text-white font-medium text-sm transition-colors"
            >
              <Phone className="w-4 h-4" /> Llamar ahora · {COMPANY.whatsapp}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
